import { ref } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { prospectsLeadsService } from '../../services/prospectService.js'
import { useProspectCache } from './useProspectCache'

/**
 * Composable for fetching prospects via TanStack Query
 */
export function useProspectList(options = {}) {
  const { isUserBusy = ref(false) } = options

  const { PROSPECTS_QUERY_KEY, updateProspectDates, updateProspectChanceToScore } =
    useProspectCache()

  const {
    data: allProspects,
    isLoading,
    error,
    refetch,
    isRefetching
  } = useQuery({
    queryKey: PROSPECTS_QUERY_KEY,
    queryFn: () => prospectsLeadsService.getAll(),
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnMount: true,
    refetchInterval: () => {
      if (isUserBusy.value) return false
      return 60_000 // 60 seconds
    },
    refetchOnWindowFocus: () => !isUserBusy.value
  })

  /**
   * Update prospect in TanStack Query cache (dates and/or chance_to_score)
   */
  function updateProspectInLocalState(updatedProspect) {
    updateProspectDates(updatedProspect)
    updateProspectChanceToScore(updatedProspect)
  }

  return {
    allProspects,
    isLoading,
    error,
    refetch,
    isRefetching,
    updateProspectInLocalState
  }
}
